import * as FaIcons from "react-icons/fa";

const STATUS_CONFIG = {
  "on time": { tone: "success", icon: FaIcons.FaCheckCircle },
  "late arrival": { tone: "warning", icon: FaIcons.FaClock },
  "half day": { tone: "warning", icon: FaIcons.FaAdjust },
  "full day": { tone: "info", icon: FaIcons.FaCalendarDay },
  "short leave": { tone: "info", icon: FaIcons.FaSignOutAlt },
  "short hours": { tone: "muted", icon: FaIcons.FaHourglassHalf },
  absent: { tone: "danger", icon: FaIcons.FaUserTimes },
  holiday: { tone: "primary", icon: FaIcons.FaUmbrellaBeach },
  weekend: { tone: "info", icon: FaIcons.FaCalendarDay },
  "emergency leave": { tone: "dark", icon: FaIcons.FaExclamationTriangle },
  "medical leave": { tone: "dangerSoft", icon: FaIcons.FaStethoscope },
  "casual leave": { tone: "neutral", icon: FaIcons.FaSmile },
  "sick leave": { tone: "dangerSoft", icon: FaIcons.FaThermometerHalf },
  "maternity leave": { tone: "primary", icon: FaIcons.FaBaby },
  "paternity leave": { tone: "primary", icon: FaIcons.FaMale },
  present: { tone: "success", icon: FaIcons.FaUserCheck },
  "missed check-out": { tone: "danger", icon: FaIcons.FaSignOutAlt },
};

const TONE_CLASS = {
  success: "border-green-200 bg-green-100 text-green-800",
  warning: "border-amber-200 bg-amber-100 text-amber-900",
  danger: "border-red-200 bg-red-100 text-red-800",
  info: "border-sky-200 bg-sky-100 text-sky-900",
  primary: "border-blue-200 bg-blue-100 text-blue-900",
  muted: "border-gray-200 bg-gray-100 text-gray-700",
  neutral: "border-gray-300 bg-white text-gray-700",
  dangerSoft: "border-red-200 bg-red-50 text-red-800",
  dark: "border-gray-700 bg-gray-700 text-white",
};

export function AttendanceStatusBadge({ status, className = "" }) {
  const normalized = status?.toLowerCase?.() || "";
  const { tone, icon: Icon } = STATUS_CONFIG[normalized] || {
    tone: "muted",
    icon: FaIcons.FaQuestionCircle,
  };

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold leading-tight ${TONE_CLASS[tone] || TONE_CLASS.muted} ${className}`}
    >
      <Icon size={13} aria-hidden />
      <span>{status || "—"}</span>
    </span>
  );
}
